export interface BrandingConfig {
  logo_url: string | null;
  logo_dark_url: string | null;
  favicon_url: string | null;
  primary_color: string;
  secondary_color: string;
  font_family: string;
  email_from_name: string | null;
  email_from_address: string | null;
  terms_url: string | null;
  privacy_url: string | null;
  support_email: string | null;
  login_message: string | null;
  dashboard_footer: string | null;
  powered_by_text: string | null;
  allow_tenant_branding: boolean;
}

export type BrandingSource = 'platform' | 'agency' | 'tenant';

export type BrandingSources = {
  [K in keyof BrandingConfig]?: BrandingSource;
};

export interface BrandingContextValue {
  branding: BrandingConfig;
  sources: BrandingSources;
  isLoading: boolean;
  error: Error | null;
  refresh: () => Promise<void>;
}

// Platform defaults - keep in sync with edge function
export const PLATFORM_DEFAULTS: BrandingConfig = {
  logo_url: null,
  logo_dark_url: null,
  favicon_url: null,
  primary_color: '#6366f1',
  secondary_color: '#8b5cf6',
  font_family: 'Inter',
  email_from_name: 'Calie',
  email_from_address: null,
  terms_url: null,
  privacy_url: null,
  support_email: null,
  login_message: null,
  dashboard_footer: null,
  powered_by_text: 'Powered by Calie',
  allow_tenant_branding: false,
};
